import { render } from "./menuDesignForm.vue?vue&type=template&id=7132d660&scoped=true"
import script from "./menuDesignForm.vue?vue&type=script&lang=js"
export * from "./menuDesignForm.vue?vue&type=script&lang=js"

import "./menuDesignForm.vue?vue&type=style&index=0&id=7132d660&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7132d660"]])

export default __exports__